import * as React from 'react'
// libs
import { WrappedFieldArrayProps } from 'redux-form'
// components
import { ReduxEntitySelect } from 'components/FormElements/ReduxForm'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
// components
import RelatedFormsSelect from '../../../RelatedFormsSelect'
// views
import { FieldsWrapper, ListWrapper, Title } from './views'
import { AddButton, CloseIcon } from 'components/Modals/SystemProcessModal/Form/components/views'
// types
import { IOption } from 'components/FormElements/Select'
import { GroupBase } from 'react-select'
// graphql
import { SECURITY_PROFILES_SELECT_QUERY } from 'graphql/securityProfiles/queries'
// utils
import { required } from 'utils/validators'
import { securityProfileProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

interface Props {
  prepareOptions: (options: (IOption & any)[]) => IOption[] | GroupBase<IOption>[]
}

const AccessList: React.FC<WrappedFieldArrayProps<any> & Props> = ({ fields }) => {
  const currentUser = useCurrentUser()

  const addField = () => fields.push({})

  const removeField = (idx: number) => () => fields.remove(idx)

  const securityProfileVariables = {
    filter: { companyId: currentUser.companyId }
  }

  const getSecurityOptions = ({ data }) => securityProfileProps.getOptions({ data })

  const securityProfilesSearch = ({ search, refetch }) =>
    refetch({
      filter: {
        name: search,
        companyId: currentUser.companyId
      }
    })

  React.useEffect(() => {
    if (!fields.length) {
      fields.push({})
    }
  }, [fields.length])

  return (
    <>
      <Title>Available to these forms:</Title>
      {fields.map((field, idx) => (
        <ListWrapper key={field}>
          <FieldsWrapper>
            <RelatedFormsSelect field={field} />
            <ReduxEntitySelect
              label='Permissions'
              validate={required}
              menuPortalTarget={null}
              getOptions={getSecurityOptions}
              name={`${field}.securityProfileId`}
              variables={securityProfileVariables}
              handleSearch={securityProfilesSearch}
              query={SECURITY_PROFILES_SELECT_QUERY}
            />
          </FieldsWrapper>
          <CloseIcon data-testid='access-list-remove' data-entity-id={idx} onClick={removeField(idx)} />
        </ListWrapper>
      ))}

      <AddButton data-testid='access-list-add' onClick={addField}>
        + add form
      </AddButton>
    </>
  )
}

export default AccessList
